import Api from '@/services/Api'

export default {
  /*
  index (name, start, pageSize) {
    var results = Api().get('unit?name=' + name + "&start=" + start + "&limit=" + pageSize) ;
    console.log("In unit service back from server results=" + results) ;
    return results ;
  },
  */
  id (placeId) {
    console.log("in place id = " + placeId) ;
    var results = Api().get("place/" + placeId) ;
    console.log("Back from API GET PLACE ID") ;
    return results ; 
  },

  placeFindMatchesOnName (placeNameFragment, needCounts, placeType, placeRelationshipForCounts) { // placeType 1 = town, 2 = state, 3 = country
    console.log("In placeFindMatchesOnName, placeNameFragment=" + placeNameFragment) ;
    var results =  Api().get('placeFindMatchesOnName?placeNameFrag=' +  placeNameFragment +
      ((needCounts) ? "&needCounts=true" : "") +
      ((placeType) ? ("&placeType=" + placeType) : "") +
      ((placeRelationshipForCounts) ? ("&placeRelationshipForCounts=" + placeRelationshipForCounts) : "")) ;
    console.log("Back in placeFindMatchesOnName, results=" + results) ;
    return results ;
  },

  create (newPlace) {
    console.log("in create place") ;
    var results = Api().post('placeCreate', newPlace) ;
    console.log("after create, results=" + results) ;
    return results ;
  },

  update (placeUpdateParms) {
    var results = Api().post('placeUpdate', placeUpdateParms) ;
    console.log("after place update, results=" + results) ;
    return results ;
  }
}



// WEBPACK FOOTER //
// ./src/services/PlaceService.js